import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {required, alpha, email, integer} from 'vee-validate/dist/rules';

extend('required', required)
extend('alpha', alpha)
extend('email', email)
extend('integer', integer)
extend('englishAlpha', {
  validate: value => value.match(/^[A-z0-9-]+$/),
  message: 'Please use only english alphabet.'
})
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
